import { connect } from 'react-redux';
import {
  compose,
  setDisplayName,
  lifecycle,
  pure,
  flattenProp
} from 'recompose';
import { createSelector } from 'reselect';

import MenuDay from '../../views/Menu/MenuDay';
import { loadDayMenu } from '../../../actions';
import { selectDayMenu } from '../../../selectors';

export default compose(
  setDisplayName('MenuDayContainer'),
  connect(
    createSelector(
      selectDayMenu(),
      menu => ({ menu })
    ),
    { loadDayMenu }
  ),
  lifecycle({
    componentDidMount() {
      this.props.loadDayMenu();
    }
  }),
  flattenProp('menu'),
  pure
)(MenuDay);
